import { Component, ComponentFactoryResolver, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import { CorePageBaseComponent } from '../shared/core-page-base.component';
import { PageElementBaseComponent } from '../shared/page-element-base.component';
import { PageResolveHelper } from './page-resolver.helper';

/**
 * The component responsible to resolve and render the building block
 */
@Component({
  selector: 'cu-page-resolver',
  template: `<ng-container #pageContainer></ng-container>`
})
export class PageResolverComponent extends PageElementBaseComponent implements OnInit {
  /**
   * Reference to  controlContainer where building block is rendered
   */
  @ViewChild('pageContainer', { static: true, read: ViewContainerRef })
  public pageContainer: ViewContainerRef;

  constructor(private readonly componentFactoryResolver: ComponentFactoryResolver, private readonly router: Router) {
    super();
  }

  public ngOnInit(): void {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    const component = new PageResolveHelper(
      this.componentFactoryResolver,
      this.pageContainer,
      this.page,
      this.flow
    ).resolve<CorePageBaseComponent>(this.page.helper.customPageType);
    component.instance.page = this.page;
    component.instance.flow = this.flow;
  }
}
